import types from './actionTypes';

function setMaskedMode(isActive: boolean) {
  return {
    type: types.SET_MASKED_MODE,
    active: isActive,
  };
}

export default {
  setMaskedMode,
};
